module.exports = __webpack_public_path__ + "static/media/multipleobjects.b0a2e24e.svg";